export let DialogPopupDataAttributes = /*#__PURE__*/function (DialogPopupDataAttributes) {
  DialogPopupDataAttributes["open"] = "data-open";
  DialogPopupDataAttributes["closed"] = "data-closed";
  DialogPopupDataAttributes["startingStyle"] = "data-starting-style";
  DialogPopupDataAttributes["endingStyle"] = "data-ending-style";
  DialogPopupDataAttributes["nested"] = "data-nested";
  DialogPopupDataAttributes["hasNestedDialogs"] = "data-has-nested-dialogs";
  return DialogPopupDataAttributes;
}({});